import React from "react";
import "./style.css";
const JoinChallengeButton = (props) => {
    const { url, color, text, className = "" } = props;
    return (React.createElement("a", { className: `join-challenge-button ${className}`, href: url, target: '_blank', style: {
            backgroundColor: color,
        } }, text));
};
export default JoinChallengeButton;
